var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-carousel-image" },
    [
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
            [_vm._v("添加轮播图")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.loadConfig } },
            [_vm._v("查询")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, border: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "标题" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.extra.title))])]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "推荐类型", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getTypeTagType(
                            scope.row.extra.recommendType
                          ),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.getTypeText(scope.row.extra.recommendType)
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "推荐内容", "min-width": "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.getRecommendContent(scope.row)) +
                        "\n             "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "开始-结束时间", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "time-range" }, [
                      _c("div", [_vm._v(_vm._s(scope.row.extra.startTime))]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(scope.row.extra.endTime))]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "适用门店",
              "min-width": "140",
              "show-overflow-tooltip": "",
              formatter: _vm.storeColumnFormatter,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "extra.sort", label: "排序", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "是否显示", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#67C23A",
                        "inactive-color": "#dcdfe6",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleVisible(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.enable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enable", $$v)
                        },
                        expression: "scope.row.enable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "200", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove(scope.row)
                          },
                        },
                      },
                      [_vm._v("移除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.currentPage,
              "page-size": _vm.pageSize,
              "page-sizes": [5, 10, 20, 50],
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "1200px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetForm,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "dialog-form",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-section" },
                    [
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("基础信息"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "标题", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入标题" },
                            model: {
                              value: _vm.formData.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "title", $$v)
                              },
                              expression: "formData.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "推荐类型", prop: "recommendType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.changeRecommendInfo },
                              model: {
                                value: _vm.formData.recommendType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "recommendType", $$v)
                                },
                                expression: "formData.recommendType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("NOTHING"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("领券弹窗"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("系统弹窗"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 5 } }, [
                                _vm._v("调查问卷"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 6 } }, [
                                _vm._v("外部小程序"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 7 } }, [
                                _vm._v("微信红包封面"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "推荐内容" } }, [
                        _vm.formData.recommendType != 1
                          ? _c(
                              "div",
                              { staticClass: "inline-items" },
                              [
                                _vm.formData.recommendType == 6
                                  ? _c(
                                      "el-select",
                                      {
                                        staticClass: "inline-select",
                                        attrs: {
                                          placeholder: "请选择小程序类型",
                                          clearable: "",
                                        },
                                        on: {
                                          change: _vm.changeRecommendContentSub,
                                        },
                                        model: {
                                          value:
                                            _vm.formData.recommendContentSub,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "recommendContentSub",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.recommendContentSub",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "社区",
                                            value: "GAGAS",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: {
                                            label: "其他",
                                            value: "other",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                (_vm.formData.recommendContentSub == "GAGAS" &&
                                  _vm.formData.recommendType == 6) ||
                                _vm.formData.recommendType == 3 ||
                                _vm.formData.recommendType == 4 ||
                                _vm.formData.recommendType == 8
                                  ? _c(
                                      "el-select",
                                      {
                                        staticClass: "inline-select",
                                        attrs: {
                                          filterable: "",
                                          placeholder: "请选择页面",
                                          clearable: "",
                                        },
                                        model: {
                                          value:
                                            _vm.formData.recommendContentId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "recommendContentId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.recommendContentId",
                                        },
                                      },
                                      _vm._l(_vm.pageList, function (opt) {
                                        return _c("el-option", {
                                          key: opt.id,
                                          attrs: {
                                            label:
                                              opt.label +
                                              " (" +
                                              (opt.appid === "GAGAX"
                                                ? "点餐"
                                                : opt.appid === "GAGAS"
                                                ? "社区"
                                                : opt.appid) +
                                              ")",
                                            value: opt.id,
                                          },
                                        })
                                      }),
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.recommendType == 2 ||
                                (_vm.formData.recommendType == 6 &&
                                  _vm.formData.recommendContentSub == "other")
                                  ? _c("el-input", {
                                      staticClass: "inline-input",
                                      attrs: {
                                        placeholder: "请输入",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.formData.recommendContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "recommendContent",
                                            $$v
                                          )
                                        },
                                        expression: "formData.recommendContent",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.recommendType == 5 ||
                                _vm.formData.recommendType == 7 ||
                                (_vm.formData.recommendType == 6 &&
                                  _vm.formData.recommendContentSub == "other")
                                  ? _c("el-input", {
                                      staticClass: "inline-input",
                                      attrs: {
                                        placeholder: "请输入URL",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.formData.recommendContentId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "recommendContentId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.recommendContentId",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.recommendType == 3 ||
                                _vm.formData.recommendType == 5 ||
                                _vm.formData.recommendType == 6 ||
                                _vm.formData.recommendType == 8
                                  ? _c("el-input", {
                                      staticClass: "inline-input",
                                      attrs: {
                                        placeholder:
                                          "请输入参数，如：id=122&name=test",
                                        clearable: "",
                                      },
                                      model: {
                                        value:
                                          _vm.formData.recommendContentParam,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "recommendContentParam",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.recommendContentParam",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "recommend-type-hint" },
                                  [
                                    _vm.formData.recommendType == 2
                                      ? _c(
                                          "span",
                                          { staticClass: "hint-text" },
                                          [
                                            _vm._v(
                                              "请填写优惠券发放活动ID（活动类型需为领取，只填写id）"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.formData.recommendType == 3 ||
                                    _vm.formData.recommendType == 4 ||
                                    _vm.formData.recommendType == 8
                                      ? _c(
                                          "span",
                                          { staticClass: "hint-text" },
                                          [
                                            _vm._v(
                                              "请选择跳转页面及输入参数，参数格式如：id=122&name=test"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.formData.recommendType == 5
                                      ? _c(
                                          "span",
                                          { staticClass: "hint-text" },
                                          [
                                            _vm._v(
                                              "请填写跳转页面地址及参数，参数格式如：id=122&name=test"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.formData.recommendType == 6
                                      ? _c(
                                          "span",
                                          { staticClass: "hint-text" },
                                          [
                                            _vm._v(
                                              "请填写外部小程序appid、跳转地址及参数，参数格式如：id=122&name=test"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.formData.recommendType == 7
                                      ? _c(
                                          "span",
                                          { staticClass: "hint-text" },
                                          [_vm._v("请填写微信红包封面地址URL")]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否会员", prop: "isVip" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.isVip,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "isVip", $$v)
                                },
                                expression: "formData.isVip",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("全部"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "分组类型", prop: "cdpGrpType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handleCdpGrpTypeChange },
                              model: {
                                value: _vm.formData.cdpGrpType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "cdpGrpType", $$v)
                                },
                                expression: "formData.cdpGrpType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不匹配"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("CDP分组"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("消费行为"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formData.cdpGrpType !== 0
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "分组选择", prop: "cdpGrpId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "inline-select",
                                  attrs: {
                                    placeholder: "请选择分组",
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    "remote-method": _vm.queryCdpGroupList,
                                    loading: _vm.cdpGroupLoading,
                                  },
                                  model: {
                                    value: _vm.formData.cdpGrpId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "cdpGrpId", $$v)
                                    },
                                    expression: "formData.cdpGrpId",
                                  },
                                },
                                _vm._l(_vm.cdpGroupOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "添加企微", prop: "isAddQy" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.isAddQy,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "isAddQy", $$v)
                                },
                                expression: "formData.isAddQy",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("全部"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "新人券是否过期",
                            prop: "isNewPeopleCoupon",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.isNewPeopleCoupon,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "isNewPeopleCoupon",
                                    $$v
                                  )
                                },
                                expression: "formData.isNewPeopleCoupon",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("全部"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("过期"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("未过期"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否下单", prop: "isSaleOrder" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.isSaleOrder,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "isSaleOrder", $$v)
                                },
                                expression: "formData.isSaleOrder",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("全部"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("下过单"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("未下过单"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发送场景", prop: "sendScene" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.formData.sendScene,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "sendScene", $$v)
                                },
                                expression: "formData.sendScene",
                              },
                            },
                            [
                              _c("el-checkbox", { attrs: { label: 3 } }, [
                                _vm._v("外卖"),
                              ]),
                              _vm._v(" "),
                              _c("el-checkbox", { attrs: { label: 1 } }, [
                                _vm._v("堂食"),
                              ]),
                              _vm._v(" "),
                              _c("el-checkbox", { attrs: { label: 2 } }, [
                                _vm._v("自提"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "时间范围", required: "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "time-picker-group" },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  placeholder: "开始时间",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  prop: "startTime",
                                },
                                model: {
                                  value: _vm.formData.startTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "startTime", $$v)
                                  },
                                  expression: "formData.startTime",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "time-separator" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  placeholder: "结束时间",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  prop: "endTime",
                                },
                                model: {
                                  value: _vm.formData.endTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "endTime", $$v)
                                  },
                                  expression: "formData.endTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "星期选项", prop: "weekDays" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.formData.weekDays,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "weekDays", $$v)
                                },
                                expression: "formData.weekDays",
                              },
                            },
                            _vm._l(_vm.weekOptions, function (day) {
                              return _c(
                                "el-checkbox",
                                { key: day.value, attrs: { label: day.value } },
                                [_vm._v(_vm._s(day.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序", prop: "sort" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 1,
                              max: 9999,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.formData.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "sort", $$v)
                              },
                              expression: "formData.sort",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "展示平台", prop: "showPlatform" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.formData.showPlatform,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "showPlatform", $$v)
                                },
                                expression: "formData.showPlatform",
                              },
                            },
                            [
                              _c("el-checkbox", { attrs: { label: 1 } }, [
                                _vm._v("微信"),
                              ]),
                              _vm._v(" "),
                              _c("el-checkbox", { attrs: { label: 2 } }, [
                                _vm._v("支付宝"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否显示", prop: "visible" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.formData.visible,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "visible", $$v)
                              },
                              expression: "formData.visible",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "展示图片", prop: "showImage" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-picture-wall",
                              attrs: {
                                action: "",
                                "list-type": "picture-card",
                                "file-list": _vm.fileList,
                                "on-change": _vm.handleImageChange,
                                "on-remove": _vm.handleImageRemove,
                                "before-upload": _vm.beforeImageUpload,
                                limit: 1,
                                "on-exceed": _vm.handleExceed,
                                accept: "image/*",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "file",
                                  fn: function (ref) {
                                    var file = ref.file
                                    return _c("div", {}, [
                                      _c("img", {
                                        staticClass:
                                          "el-upload-list__item-thumbnail",
                                        attrs: {
                                          src: _vm.imagePrefix + file.url,
                                          alt: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-actions",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-preview",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleImagePreview(
                                                    file
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-zoom-in",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-delete",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleImageRemove(
                                                    file
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  },
                                },
                              ]),
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { slot: "default" },
                                slot: "default",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dialog",
                            {
                              attrs: {
                                visible: _vm.previewVisible,
                                size: "tiny",
                                "append-to-body": "",
                              },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.previewVisible = $event
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  width: "100%",
                                  src: _vm.getImageUrl(_vm.previewImageUrl),
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "store-panel" },
                [
                  _c(
                    "div",
                    { staticClass: "store-panel-header" },
                    [
                      _c("span", [
                        _c("i", { staticClass: "el-icon-office-building" }),
                        _vm._v(" 选择门店"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: { click: _vm.selectAllStores },
                        },
                        [
                          _c("i", { staticClass: "el-icon-check" }),
                          _vm._v(" 全选\n                "),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "store-panel-tip" }, [
                    _vm._v(
                      "已选 " +
                        _vm._s(_vm.selectedShopsCount) +
                        " 家门店，不选默认全部门店展示"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      placeholder: "搜索门店名称",
                      "prefix-icon": "el-icon-search",
                      clearable: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.storeSearchText,
                      callback: function ($$v) {
                        _vm.storeSearchText = $$v
                      },
                      expression: "storeSearchText",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "store-tree" },
                    [
                      _c("el-tree", {
                        ref: "storeTree",
                        attrs: {
                          data: _vm.storeTreeData,
                          props: _vm.defaultProps,
                          "default-expanded-keys": _vm.expandedKeys,
                          "filter-node-method": _vm.filterNode,
                          "show-checkbox": "",
                          "node-key": "nodeKey",
                        },
                        on: { check: _vm.handleStoreCheck },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览二维码",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览二维码" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }